export const STATUS_PROCESSING = 1;
export const STATUS_DONE = 2;
export const STATUS_FAIL = 3;

export const statuses = [
  { value: STATUS_PROCESSING, name: 'STATUS_PROCESSING', cssClass: 'yellow' },
  { value: STATUS_DONE, name: 'STATUS_DONE', cssClass: 'green' },
  { value: STATUS_FAIL, name: 'STATUS_FAIL', cssClass: 'red' },
];
